(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-sopd-track]');
    var viewport = root.querySelector('.sopd-carousel-viewport');
    var prevBtn = root.querySelector('[data-sopd-prev]');
    var nextBtn = root.querySelector('[data-sopd-next]');
    if (!track || !viewport) return;

    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    var perViewDesktop = parseInt(root.getAttribute('data-per-view-desktop'), 10) || 2;
    var perViewMobile = parseInt(root.getAttribute('data-per-view-mobile'), 10) || 1;
    var loop = root.getAttribute('data-loop') === 'true';
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4000;

    root.style.setProperty('--sopd-per-view-desktop', perViewDesktop);
    root.style.setProperty('--sopd-per-view-mobile', perViewMobile);

    var index = 0;
    var autoplayTimer = null;
    var isDragging = false;
    var dragStartX = 0;
    var dragDelta = 0;
    var startTransform = 0;

    function perView() {
      return window.matchMedia('(max-width: 749px)').matches ? perViewMobile : perViewDesktop;
    }

    function maxIndex() {
      return Math.max(slides.length - perView(), 0);
    }

    function slideWidth() {
      return slides[0].getBoundingClientRect().width;
    }

    function gap() {
      var style = window.getComputedStyle(track);
      return parseFloat(style.columnGap || style.gap || 0) || 0;
    }

    function goTo(newIndex, instant) {
      var max = maxIndex();

      if (loop) {
        if (newIndex < 0) newIndex = max;
        if (newIndex > max) newIndex = 0;
      } else {
        newIndex = Math.min(Math.max(newIndex, 0), max);
      }

      index = newIndex;
      var offset = index * (slideWidth() + gap());

      track.style.transition = instant ? 'none' : 'transform 0.45s ease';
      track.style.transform = 'translateX(' + -offset + 'px)';

      updateButtons();
    }

    function updateButtons() {
      if (!prevBtn || !nextBtn) return;
      if (loop) {
        prevBtn.disabled = false;
        nextBtn.disabled = false;
        return;
      }
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= maxIndex();
    }

    function next() {
      goTo(index + 1);
    }

    function prev() {
      goTo(index - 1);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      autoplayTimer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    // Touch / drag support
    function onDragStart(clientX) {
      isDragging = true;
      dragStartX = clientX;
      dragDelta = 0;
      startTransform = index * (slideWidth() + gap());
      track.style.transition = 'none';
      track.classList.add('sopd-dragging');
      stopAutoplay();
    }

    function onDragMove(clientX) {
      if (!isDragging) return;
      dragDelta = clientX - dragStartX;
      track.style.transform = 'translateX(' + (-startTransform + dragDelta) + 'px)';
    }

    function onDragEnd() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('sopd-dragging');

      var threshold = slideWidth() * 0.2;
      if (dragDelta < -threshold) {
        next();
      } else if (dragDelta > threshold) {
        prev();
      } else {
        goTo(index);
      }
      startAutoplay();
    }

    track.addEventListener('touchstart', function (e) {
      onDragStart(e.touches[0].clientX);
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      onDragMove(e.touches[0].clientX);
    }, { passive: true });

    track.addEventListener('touchend', onDragEnd);

    track.addEventListener('mousedown', function (e) {
      e.preventDefault();
      onDragStart(e.clientX);
    });

    window.addEventListener('mousemove', function (e) {
      if (isDragging) onDragMove(e.clientX);
    });

    window.addEventListener('mouseup', onDragEnd);

    if (autoplay) {
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        goTo(Math.min(index, maxIndex()), true);
      }, 150);
    });

    goTo(0, true);
    startAutoplay();

    // Re-init on theme editor block changes
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.contains(root)) {
        goTo(0, true);
      }
    });
  }

  function init() {
    var carousels = document.querySelectorAll('[data-sopd-carousel]');
    carousels.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
